// extracted by mini-css-extract-plugin
export default {"tabs":"_14Dp8g-Xdl","icon":"_8d8fxAEDQP","divider":"_3BVJKiGcNi"};
    if(module.hot) {
      // 1625219461661
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  